import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { Color, MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import * as Chart from 'chart.js';
import { ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { ClienteModule } from '../../modelo/cliente/cliente.module';
import { LocalesModule } from '../../modelo/locales/locales.module';
import { categoriaModule } from '../../modelo/usuario/categoria';
import { ventaLocalModule } from '../../modelo/usuario/ventaLocal';
import { LoginService } from '../../servicios/login.service';
import { ReporteService } from '../../servicios/reporte.service';

@Component({
  selector: 'app-report-meta',
  templateUrl: './report-meta.component.html',
  styleUrls: ['./report-meta.component.css']
})
export class ReportMetaComponent implements OnInit {
  alertService: any;
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  @ViewChild(MdbTableDirective) mdbTableDev: MdbTableDirective;


  constructor(private api: ReporteService,private apiLogin: LoginService) { }
  anioselec: string;
  categoria: string;
  meseSelec: string[];
  aniosselec: string[];
  listCategoria: categoriaModule[];
  cat: categoriaModule;
  selectedProduc: [];
  catSelec: string[];
  productos: ventaLocalModule[];
  anios: [];
  totalventa: number;
  totalventa1: number;
  anio1: string;
  anio0: number;
  anio11: number;
  anio2: string;
  totaldevolucion: number;
  totaldevolucion1: number;
  totalMetadevolucion: number;
  totalMetaVenta: number;
  ventaLocal: ventaLocalModule[];
  ListVentaLocal: ventaLocalModule[];
  ListVentaLocal1: ventaLocalModule[];
  aniotexto: string;
  aniotexto1: string;
 id_pais:string;
 pais:boolean;
 usuario:string;
 listaLocales:LocalesModule[];
 habilitar:boolean;
 id:string;
  local: string;
  meses: [];
  mesesMostrar: [];
  mesesAnio = [
    { id: 1, name: 'Enero' },
    { id: 2, name: 'Febrero' },
    { id: 3, name: 'Marzo' },
    { id: 4, name: 'Abril' },
    { id: 5, name: 'Mayo' },
    { id: 6, name: 'Junio' },
    { id: 7, name: 'Julio' },
    { id: 8, name: 'Agosto' },
    { id: 9, name: 'Septiembre' },
    { id: 10, name: 'Octubre' },
    { id: 11, name: 'Noviembre' },
    { id: 12, name: 'Diciembre' },
  ];



  lineChartData: ChartDataSets[] = [

  ];

  lineChartDataDevo: ChartDataSets[] = [

  ];

  lineChartLabels: Label[] = [];

  lineChartOptions = {
    responsive: true,
  };

  lineChartColors: Color[] = [
    {
      borderColor: 'black',
      backgroundColor: 'rgba(1,1,1,0)',
    },
    {
      borderColor: 'red',
      backgroundColor: 'rgba(1,1,1,0)',
    },
    {
      borderColor: 'blue',
      backgroundColor: 'rgba(1,1,1,0)',
    },
    {
      borderColor: 'orange',
      backgroundColor: 'rgba(1,1,1,0)',
    },
    {
      borderColor: 'yellow',
      backgroundColor: 'rgba(1,1,1,0)',
    },
  ];

  lineChartLegend = true;
  lineChartPlugins = [];
  lineChartType = 'line';


  public  cargarLocales(){
    this.apiLogin.locales(localStorage.getItem("id_pais"))
    .subscribe((
      data: LocalesModule[]) => {
      this.listaLocales = data;
      this.usuario=localStorage.getItem("nombre");
      this.local=localStorage.getItem("nombreLocal");
      this.id=localStorage.getItem("local");
      if (localStorage.getItem("rol")=='MaxiPan' || localStorage.getItem("rol")=='Gerencia CF' )
    {     this.habilitar=false;
    }else{
     this.habilitar=true;
    }
     console.log(this.listaLocales);
     this.listaLocales.forEach(item => {
      if (item.id.toString() ==this.id){
        localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
      }
      
    });
    },
   // err =>  this.alertService.danger('Error no hay  conexion..')
    );
  }


  onChangeLocal($event: Event) {
  
    localStorage.setItem('id', this.id);
    this.listaLocales.forEach(item => {
      if (item.id.toString() ==this.id){
        localStorage.setItem('nombreLocal', item.Nombre_ClientesFinales);  
        this.usuario=localStorage.getItem('nombre');
      this.local=localStorage.getItem('nombreLocal');
      this.id_pais=localStorage.getItem("id_pais");

  

      }
      
    });

    this.id_pais=localStorage.getItem("id_pais");
    this.listarAnioxLocal();
    this.categoriaxLocal();
    this.meseSelec = [];
    this.ListVentaLocal = [];
    //this.catSelec = []; 
    if (this.id_pais==='593'){
      this.pais=true;
    }else{
      this.pais=false;

    }
    this.productos = [];
    this.listarProductos();
    //this.aniosselec = [];
    this.selectedProduc = [];
    this.local = localStorage.getItem("nombreLocal");
    Chart.defaults.global.defaultFontSize = 15;
  
   
    }
  public polarAreaChartType = 'polarArea';
  ngOnInit(): void {


    this.id_pais=localStorage.getItem("id_pais");
    this.cargarLocales();
    this.meseSelec = [];
    this.ListVentaLocal = [];
    this.catSelec = [];
    if (this.id_pais==='593'){
      this.pais=true;
    }else{
      this.pais=false;

    }
    this.aniosselec = [];
    this.id_pais=localStorage.getItem("id_pais");
    this.listarAnioxLocal();
    this.categoriaxLocal();
    this.meseSelec = [];
    this.ListVentaLocal = [];
    this.catSelec = [];
    if (this.id_pais==='593'){
      this.pais=true;
    }else{
      this.pais=false;

    }
    this.productos = [];
    this.listarProductos();
  
    this.selectedProduc = [];
    this.local = localStorage.getItem("nombreLocal");
    Chart.defaults.global.defaultFontSize = 15;
  
   
  }

  listarProductos() {

    this.api.productoLocal(localStorage.getItem("nombreLocal").substring(0, 3),this.id_pais).subscribe((
      data: []) => {
      this.productos = data;

    },
      err => this.alertService.danger('Error no hay  conexion..')
    );
  }
  listarDetalleVentaUno(anio: string, mes: string, categorias: string, productos: string) {
    this.totalventa = 0;
    this.totaldevolucion = 0;
    this.totalventa1 = 0;
    this.totaldevolucion1 = 0;
    this.totalMetadevolucion = 0;
    this.totalMetaVenta = 0;
    this.api.detVentaxlocalxMeta(localStorage.getItem("nombreLocal").substring(0, 3), anio, mes, categorias, productos,this.id_pais).subscribe((
      data: []) => {
      this.ListVentaLocal = data;

      this.listarDetalleVentaDOS(this.anio11.toString(), mes, categorias, productos);


    },
      err => this.alertService.danger('Error no hay  conexion..')
    );
  }


  listarDetalleVentaDOS(anio: string, mes: string, categorias: string, productos: string) {
    this.totalventa = 0;
    this.totaldevolucion = 0;
    this.totalMetadevolucion = 0;
    this.totalMetaVenta = 0;
    this.api.detVentaxlocalxMeta(localStorage.getItem("nombreLocal").substring(0, 3), anio, mes, categorias, productos,this.id_pais).subscribe((
      data: []) => {
      this.ListVentaLocal1 = data;

      this.ListVentaLocal1.forEach(element => {
        this.ListVentaLocal.forEach(element1 => {
          if (element.codigo == element1.codigo) {
            element1.venta1 = element.venta
            element1.devolucion1 = element.devolucion
            element1.meta_venta = Math.round(element.meta_venta)
            element1.meta_devolucion = Math.round(element.meta_devolucion)
          }

        });
      });

      this.totalventa = 0;
      this.totaldevolucion = 0;
      this.totalventa1 = 0;
      this.totaldevolucion1 = 0;
      this.totalMetadevolucion = 0;
      this.totalMetaVenta = 0;

      this.ListVentaLocal.forEach(element => {
        this.totalventa = this.totalventa + Number.parseFloat(element.venta.toString());
        this.totaldevolucion = this.totaldevolucion + Number.parseFloat(element.devolucion.toString());

      });
      this.ListVentaLocal.forEach(element => {
        if (isNaN(element.venta1)) {
        } else {
          this.totalventa1 = this.totalventa1 + Number.parseFloat(element.venta1.toString());
        }
        if (isNaN(element.devolucion1)) {
        } else {
          this.totaldevolucion1 = this.totaldevolucion1 + Number.parseFloat(element.devolucion1.toString());
        }
      });

      this.ListVentaLocal.forEach(element => {
        this.totalMetaVenta = this.totalMetaVenta + Number.parseFloat(element.meta_venta.toString());
        this.totalMetadevolucion = this.totalMetadevolucion + Number.parseFloat(element.meta_devolucion.toString());

      });

      this.mdbTable.setDataSource(this.ListVentaLocal);
      //this.mdbTablePagination.setMaxVisibleItemsNumberTo(10)
      this.mdbTable.dataSourceChange();

      this.mdbTableDev.setDataSource(this.ListVentaLocal);
      // this.mdbTablePagination.setMaxVisibleItemsNumberTo(10)
      this.mdbTableDev.dataSourceChange();





    },
      err => this.alertService.danger('Error no hay  conexion..')
    );
  }

  onKeypressEvent(value: string) {
    let valida = false;
    this.productos = this.productos.filter((item) => {
      if (item.producto.toUpperCase().indexOf(value.toUpperCase()) > -1) {
        valida = true;
        return item.producto.toUpperCase().indexOf(value.toUpperCase()) > -1;
      }
    });
    if (valida == false) {
      this.listarProductos();
    }
  }



  listarDetalleVenta(anio: string, mes: string, categorias: string, productos: string) {
    this.totalventa = 0;
    this.totaldevolucion = 0;
    this.totalMetadevolucion = 0;
    this.totalMetaVenta = 0;
    this.aniotexto = anio;
    this.api.detVentaxlocalxMeta(localStorage.getItem("nombreLocal").substring(0, 3), anio, mes, categorias, productos,this.id_pais).subscribe((
      data: []) => {
      this.ListVentaLocal = data;

      this.totalventa = 0;
      this.totaldevolucion = 0;
      this.totalMetadevolucion = 0;
      this.totalMetaVenta = 0;
      this.ListVentaLocal.forEach(element => {
        this.totalventa = this.totalventa + Number.parseFloat(element.venta.toString());
        this.totaldevolucion = this.totaldevolucion + Number.parseFloat(element.devolucion.toString());

      });
      this.ListVentaLocal.forEach(element => {
        this.totalMetaVenta = this.totalMetaVenta + Number.parseFloat(element.meta_venta.toString());
        this.totalMetadevolucion = this.totalMetadevolucion + Number.parseFloat(element.meta_devolucion.toString());

      });
      this.mdbTable.setDataSource(this.ListVentaLocal);
      this.mdbTable.dataSourceChange();

      this.mdbTableDev.setDataSource(this.ListVentaLocal);
      this.mdbTableDev.dataSourceChange();


    },
      err => this.alertService.danger('Error no hay  conexion..')
    );
  }
  onChangeArticulo(event: Event) {
   // this.ventaPorLocal();
    this.listarProductos();
  }
  ventaPorLocal() {
    let meses = "";
    let aniostring = "";
    let categorias = "";
    let productos = "";
    let datos: any[];
    let datosDev: any[];
    let datosMetaVenta: any[];
    let datosMetaDevolucion: any[];

    let datos2: any[];
    let datosDev2: any[];
    let datosMetaVenta2: any[];
    let datosMetaDevolucion2: any[];

    let mesesOrderna: number[];

    mesesOrderna = [];

    this.meseSelec.forEach(element => {
      meses = meses + element + ",";
      mesesOrderna.push(Number.parseInt(element));
    });
    let mesOrdenador = mesesOrderna.sort((a, b) => a - b);
    this.aniosselec.forEach(element => {
      aniostring = aniostring + element + ",";
    });
    this.catSelec.forEach(element => {
      categorias = categorias + "'" + element + "',";
    });

    this.selectedProduc.forEach(element => {

      productos = productos + "'" + element + "',";
    });
    if (aniostring.length > 0) {
      aniostring = aniostring + '0';
    } else {
      aniostring = "''"
    }
    if (meses.length > 0) {
      meses = meses + '0';
    } else {
      meses = "''"
    }
    if (categorias.length > 0) {
      categorias = categorias + "'0'"
    } else {
      categorias = "''"
    }

    if (productos.length > 0) {
      productos = productos + "'0'"
    } else {
      productos = "NO"
    }


    datos = [];
    datosDev = [];
    datosMetaDevolucion = [];
    datosMetaVenta = [];
    datos2 = [];
    datosDev2 = [];
    datosMetaDevolucion2 = [];
    datosMetaVenta2 = [];
    this.lineChartLabels = [];
    if (this.aniosselec.length > 1) {
      if (this.aniosselec[0] > this.aniosselec[1]) {
        this.anio0 = Number.parseInt(this.aniosselec[1]);
        this.anio11 = Number.parseInt(this.aniosselec[0]);

      } else {
        this.anio0 = Number.parseInt(this.aniosselec[0]);
        this.anio11 = Number.parseInt(this.aniosselec[1]);
      }
    } else {
      this.anio0 = Number.parseInt(this.aniosselec[0]);
    }
    if (this.aniosselec.length <= 1) {
      this.aniotexto1 = "";
      this.totalventa = 0;
      this.totaldevolucion = 0;
      this.totalventa1 = 0;
      this.totaldevolucion1 = 0;
      this.totalMetadevolucion = 0;
      this.totalMetaVenta = 0;
      if (isNaN(this.anio0)){
        this.anio0=0;
      }
      this.listarDetalleVenta(this.anio0.toString(), meses, categorias, productos);
     this.api.ventaxlocalMeta(localStorage.getItem("nombreLocal").substring(0, 3), this.anio0.toString(), meses, categorias, productos,this.id_pais).subscribe((
        data: []) => {
        this.anio1 = this.aniosselec[0];
        this.ventaLocal = data;
        this.ventaLocal.forEach(element => {
          datos.push(element.venta)
          datosDev.push(element.devolucion);
          datosMetaDevolucion.push(Math.round(element.meta_devolucion));
          datosMetaVenta.push(Math.round(element.meta_venta));
          // this.lineChartData.push(element.venta);
          this.lineChartLabels = [];
          mesOrdenador.forEach(mes => {
            if (mes === 1) {
              this.lineChartLabels.push('ENERO')
            }
            if (mes === 2) {
              this.lineChartLabels.push('FEBRERO')
            }
            if (mes === 3) {
              this.lineChartLabels.push('MARZO')
            }
            if (mes === 4) {
              this.lineChartLabels.push('ABRIL')
            }
            if (mes === 5) {
              this.lineChartLabels.push('MAYO')
            }
            if (mes === 6) {
              this.lineChartLabels.push('JUNIO')
            }
            if (mes === 7) {
              this.lineChartLabels.push('JULIO')
            }
            if (mes === 8) {
              this.lineChartLabels.push('AGOSTO')
            }
            if (mes === 9) {
              this.lineChartLabels.push('SEPTIEMBRE')
            }
            if (mes === 10) {
              this.lineChartLabels.push('OCTUBRE')
            }
            if (mes === 11) {
              this.lineChartLabels.push('NOVIEMBRE')
            }

            if (mes === 12) {
              this.lineChartLabels.push('DICIEMBRE')
            }




          });



        });
        if (datos.length > 0 || datosMetaVenta.length > 1) {
          if (datosMetaVenta[0] > 0) {
            this.lineChartData.push
            this.lineChartData = [
              { data: datos, label: 'Ventas ' + this.anio1 },
              { data: datosMetaVenta, label: 'Meta Venta ' + this.anio1 },

            ];
          } else {
            this.lineChartData.push
            this.lineChartData = [
              { data: datos, label: 'Ventas ' + this.anio1 },

            ];
          }
        }
        if (datos.length > 0 || datosMetaDevolucion.length > 0) {
          if (datosMetaDevolucion[0] > 0) {
            this.lineChartDataDevo.push
            this.lineChartDataDevo = [
              { data: datosDev, label: ' Devolucion ' + this.anio1 },
              { data: datosMetaDevolucion, label: 'Meta  Devolucion ' + this.anio1 },
            ];
          } else {
            this.lineChartDataDevo.push
            this.lineChartDataDevo = [
              { data: datosDev, label: ' Devolucion ' + this.anio1 },
            ];

          }
        } else {
          this.lineChartDataDevo = [];
        
        }
        console.log(this.ventaLocal);
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
    } else {

      datos = [];
      datosDev = [];
      datosMetaDevolucion = [];
      datosMetaVenta = [];
      this.aniotexto = this.anio0.toString();
      this.aniotexto1 = this.anio11.toString();
      this.listarDetalleVentaUno(this.anio0.toString(), meses, categorias, productos);
      this.api.ventaxlocalMeta(localStorage.getItem("nombreLocal").substring(0, 3), this.anio0.toString(), meses, categorias, productos,this.id_pais).subscribe((
        data: []) => {
        this.anio1 = this.aniosselec[0];
        this.ventaLocal = data;
        this.ventaLocal.forEach(element => {
          datos.push(element.venta)
          datosDev.push(element.devolucion);
          datosMetaDevolucion.push(Math.round(element.meta_devolucion));
          datosMetaVenta.push(Math.round(element.meta_venta));
          // this.lineChartData.push(element.venta);
        });
        this.api.ventaxlocalMeta(localStorage.getItem("nombreLocal").substring(0, 3), this.anio11.toString(), meses, categorias, productos,this.id_pais).subscribe((
          data: []) => {
          this.anio1 = this.aniosselec[0];
          this.ventaLocal = data;
          this.ventaLocal.forEach(element => {
            datos2.push(element.venta)
            datosDev2.push(element.devolucion);
            datosMetaDevolucion2.push(Math.round(element.meta_devolucion));
            datosMetaVenta2.push(Math.round(element.meta_venta));
            // this.lineChartData.push(element.venta);
            this.lineChartLabels = [];
            mesOrdenador.forEach(mes => {
              if (mes === 1) {
                this.lineChartLabels.push('ENERO')
              }
              if (mes === 2) {
                this.lineChartLabels.push('FEBRERO')
              }
              if (mes === 3) {
                this.lineChartLabels.push('MARZO')
              }
              if (mes === 4) {
                this.lineChartLabels.push('ABRIL')
              }
              if (mes === 5) {
                this.lineChartLabels.push('MAYO')
              }
              if (mes === 6) {
                this.lineChartLabels.push('JUNIO')
              }
              if (mes === 7) {
                this.lineChartLabels.push('JULIO')
              }
              if (mes === 8) {
                this.lineChartLabels.push('AGOSTO')
              }
              if (mes === 9) {
                this.lineChartLabels.push('SEPTIEMBRE')
              }
              if (mes === 10) {
                this.lineChartLabels.push('OCTUBRE')
              }
              if (mes === 11) {
                this.lineChartLabels.push('NOVIEMBRE')
              }

              if (mes === 12) {
                this.lineChartLabels.push('DICIEMBRE')
              }




            });



          });
          if (datos.length > 0 || datosMetaVenta2.length > 1) {
            if (datosMetaVenta2[0] > 0) {
              this.lineChartData.push
              this.lineChartData = [
                { data: datos, label: 'Ventas ' + this.anio0 },
                { data: datos2, label: 'Ventas ' + this.anio11 },
                { data: datosMetaVenta2, label: 'Meta Venta ' + this.anio11 },

              ];
            } else {
              this.lineChartData.push
              this.lineChartData = [
                { data: datos, label: 'Ventas ' + this.anio0 },
                { data: datos2, label: 'Ventas ' + this.anio11 },
              ];
            }
          } else {
            this.lineChartData = [];
          }
          if (datos.length > 0 || datosMetaDevolucion2.length > 1) {
            if (datosMetaDevolucion2[0] > 0) {
              this.lineChartDataDevo.push
              this.lineChartDataDevo = [
                { data: datosDev, label: ' Devolucion ' + this.anio0 },
                { data: datosDev2, label: ' Devolucion ' + this.anio11 },
                { data: datosMetaDevolucion2, label: 'Meta  Devolucion ' + this.anio11 },
              ];
            } else {
              this.lineChartDataDevo.push
              this.lineChartDataDevo = [
                { data: datosDev, label: ' Devolucion ' + this.anio0 },
                { data: datosDev2, label: ' Devolucion ' + this.anio11 },
              ];
            }
          } else {
            this.lineChartData = [];
          }
          console.log(this.ventaLocal);
        },
          err => this.alertService.danger('Error no hay  conexion..')
        );


        console.log(this.ventaLocal);
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );



    }



  }


  fieldsChange(ev): void {

    if (ev.target.checked) {
      this.aniosselec.push(ev.target.defaultValue);
    } else {
      const index: number = this.aniosselec.indexOf(ev.target.defaultValue);
      if (index !== -1) {
        this.aniosselec.splice(index, 1);

      }
    }
    this.listarMesesVendidos();
    //this.ventaPorLocal();



  }


  buscar(){
    this.ventaPorLocal();

  }


  fieldsChangeCategoria(ev): void {

    if (ev.target.checked) {
      //this.listarMesesVendidos(ev.target.defaultValue)
      this.catSelec.push(ev.target.defaultValue);
      //this.ventaPorLocal();
    } else {
      if (ev.target.checked == false) {
        const index: number = this.catSelec.indexOf(ev.target.defaultValue);
        if (index !== -1) {
          this.catSelec.splice(index, 1);
         // this.ventaPorLocal();
        }
      }

    }

  }
  fieldsChangeMes(ev): void {

    if (ev.target.checked) {
      this.meseSelec.push(ev.target.defaultValue);
    } else {
      const index: number = this.meseSelec.indexOf(ev.target.defaultValue);
      if (index !== -1) {
        this.meseSelec.splice(index, 1);

      }
    }

    //this.ventaPorLocal();
    console.log(this.meseSelec);
  }

  listarMesesVendidos() {
    this.mesesMostrar = [];
    this.mesesAnio.forEach(element => {
      this.mesesMostrar.push(element as never);
    });

    /*  this.api.meses(localStorage.getItem("nombreLocal"),anio).subscribe((
        data: []) => {
        this.meses=data;
        this.meses.forEach(mes => {
        this.mesesAnio.forEach(element => {
            if (element.id==mes[0]){
              this.mesesMostrar.push(element);
            }
          });
         
        });
      
      },
      err =>  this.alertService.danger('Error no hay  conexion..')
      );
      console.log(this.mesesMostrar);
      */
  }



  listarAnioxLocal() {
   if (this.aniosselec.length==0){
    this.api.anios(localStorage.getItem("nombreLocal"),this.id_pais).subscribe((
      data: []) => {
      this.anios = data;
      console.log(this.anios);
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );
  }
}

  categoriaxLocal() {
    if (this.catSelec.length==0){
    this.listCategoria = [];
    let i = 0;
    this.api.categoriaLocal(localStorage.getItem("nombreLocal"),this.id_pais).subscribe((
      data: []) => {
      data.forEach(element => {
        console.log(element[0]);
        this.cat = new categoriaModule();
        this.cat.name = element[0];
        this.cat.id = i;
        this.listCategoria.push(this.cat);
        i++;
      });

      console.log(this.listCategoria);
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );
  }
  }



}
